import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import LazyImage from "../../shared/lazy-image";

const HappyPurchaseCard = ({cardImage, heading, rating, stars, content}) => {
    return (
        <div styleName={"styles.outer"}>
            <LazyImage styleName={"styles.outerImage"} src={cardImage} />
            <div styleName={"styles.contentWrap"}>
                <p styleName={"styles.heading"}>{heading}</p>
                <p styleName={"styles.ratingText"}>{rating}<LazyImage styleName={"styles.ratingImage"} src={stars} /></p>
                <p styleName={"styles.content"}>{content}</p>
            </div>
        </div>
    );
};

HappyPurchaseCard.propTypes = {
    cardImage: PropTypes.string,
    heading: PropTypes.string,
    rating: PropTypes.string,
    stars: PropTypes.string,
    content: PropTypes.string
};

export default HappyPurchaseCard;

